import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isEmpty } from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import MessageInterface from '../../../api/MessageInterface';
import InboxMessagesProvider from '../../../components/InboxMessagesProvider';
import NotificationContext from '../../../context/NotificationContext';
import DynamicAction from '../../../utils/DynamicAction';
import audio from '../../../utils/audio';
import { TEXT_KEY, getText } from '../../../utils/localization';
import transformObjectArrayResponse from '../../../utils/transformObjectArrayResponse';

var useMessageDetail = function useMessageDetail(_ref) {
  var activeMessage = _ref.activeMessage,
      setActiveMessage = _ref.setActiveMessage,
      navigation = _ref.navigation;
  var context = useContext(NotificationContext);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      messageDetail = _useState2[0],
      setMessageDetail = _useState2[1];

  var fetchMessageDetail = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var msgDetails;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return MessageInterface.getInboxMessageDetails(activeMessage);

          case 3:
            msgDetails = _context.sent;
            msgDetails.reward_info = transformObjectArrayResponse(msgDetails.reward_info);
            InboxMessagesProvider.readMessage(activeMessage);
            setMessageDetail(msgDetails);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  })), [activeMessage]);
  useEffect(function () {
    fetchMessageDetail();
  }, [fetchMessageDetail]);

  var onPressHandler = function onPressHandler() {
    var action = messageDetail.action;
    audio.onClick();
    if (isEmpty(action)) setActiveMessage(null);else DynamicAction.getActionCallback(action, navigation, context)();
  };

  var handleButtonLabel = function handleButtonLabel() {
    var reward_info = messageDetail.reward_info,
        action = messageDetail.action,
        btn_text = messageDetail.btn_text;
    if (isEmpty(reward_info) && !isEmpty(action) && btn_text) return btn_text.toUpperCase();
    return getText(TEXT_KEY.OK);
  };

  return {
    messageDetail: messageDetail,
    onPressHandler: onPressHandler,
    handleButtonLabel: handleButtonLabel
  };
};

export default useMessageDetail;